<template>
  <v-application v-if="access.material_report">
    <v-settings>
      <v-toolbar flat>
        <v-toolbar-title class="ml-1">
          <b>{{ $t("material_report") }}</b></v-toolbar-title
        >
      </v-toolbar>
      <v-card>
        <v-row class="mr-5">
          <v-col>
            <v-autocomplete
              class="ml-5"
              dense
              v-model="otchot_store"
              :label="$t('store')"
              :items="otchot_stores"
              hide-details
              @change="ClickStores"
              item-text="name"
              item-value="_id"
            /> </v-col
        ></v-row>
        <v-row class="mr-5">
          <v-col cols="11" sm="6">
            <v-menu
              ref="menu"
              v-model="menuMatrial1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="490px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="ml-5"
                  v-model="dateMatireal1"
                  prepend-icon="mdi-calendar"
                  readonly
                  label="Start date"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateMatireal1"
                @input="menuMatrial1 = false"
              >
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="11" sm="6">
            <v-menu
              v-model="menuMatrial2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateMatireal2"
                  label="End date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateMatireal2"
                @input="menuMatrial2 = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-card-actions>
          <template>
            <v-btn block @click="downloadOtchot" :disabled="disabledButton">
              <v-icon color="#70f716">mdi-file-excel</v-icon
              >{{ $t("download") }}</v-btn
            >
          </template>
        </v-card-actions>
      </v-card>
    </v-settings>
    <v-settings>
      <v-toolbar flat>
        <v-toolbar-title class="ml-1">
          <b>{{ $t("sale_report") }}</b></v-toolbar-title
        >
      </v-toolbar>
      <v-card>
        <v-row>
          <v-col cols="11" sm="5">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="490px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="ml-5"
                  v-model="date1"
                  prepend-icon="mdi-calendar"
                  readonly
                  label="Start date"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date1" @input="menu1 = false">
                <!-- <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu1 = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu1.save(date1)">
                  OK
                </v-btn> -->
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="11" sm="5">
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="490px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="ml-5"
                  v-model="date2"
                  prepend-icon="mdi-calendar"
                  readonly
                  label="End date"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date2" @input="menu2 = false">
                <!-- <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu2 = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu2.save(date2)">
                  OK
                </v-btn> -->
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon @click="downloadSale">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-settings>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import fileSaver from "file-saver";
import xlsx from "xlsx";
export default {
  data: () => ({
    dateMatireal1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    dateMatireal2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menuMatrial1: false,
    menuMatrial2: false,
    menu1: false,
    menu2: false,
    otchot_store: {},
    otchot_stores: [],
    disabledButton: true,
  }),
  methods: {
    ClickStores(_id) {
      if (_id) {
        this.disabledButton = false;
      }
    },
    async downloadSale() {
      const date1 = new Date(this.date1).getTime();
      const date2 = new Date(this.date2).getTime() + 24 * 60 * 60 * 1000 - 1;
      const sale = this.$communicator.then(
        this,
        await this.$communicator("sale_report_excel", {
          arguments: [date1, date2, "all", 1],
        })
      );
      const result = sale?.data.map((itm) => {
        return {
          "Receipt №": itm.receipt_no,
          "Tip realizatsiya": itm.payment.find((payment) => payment.name === 'debt') ? 'Debt': 'Sale',
          Store: itm.service_name,
          Sku: itm.sku,
          Date: this.date_ddmmyy(itm.date),
          Client: itm.client_name.trim(),
          INN: itm.inn,
          SaleType: itm.is_refund ? this.$t("refund") : this.$t("sold"),
          Item: itm.product_name,
          "Box qty": itm.qty_box,
          Qty: itm.value,
          Price: itm.price,
          Partition: itm.partiation_no,
          Category: itm.category_name,
          // "Jami qiymat": "",
          "Skidka": itm.discount instanceof Array ? itm.discount?.reduce((sum, discount) => sum + discount.total_value, 0) : 0,
          "Total price": itm.tota_price,
          "Qty/Box qty": itm.sold_by,
          "Alt group": itm.alt_group,
          Size: itm.itm?.size,
          Employee: itm.cashier_name,
        }
      });
      const ws = xlsx.utils.json_to_sheet(result);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "SaleItemsReport.xlsx");
    },
    async downloadOtchot() {
      const dateStart = new Date(this.dateMatireal1).getTime();
      const dateEnd =
        new Date(this.dateMatireal2).getTime() + 24 * 60 * 60 * 1000 - 1;
      const link = `invan-download/inventory/otchot/excel/${
        this.otchot_store ? this.otchot_store : ""
      }/${dateStart}/${dateEnd}`;
      this.$communicator.downloadDocument(link, `Otchot.xls`, "2.0.0");
    },
    async getServices() {
      const services = this.$communicator.then(
        this,
        await this.$communicator("services")
      );
      this.otchot_stores = services;
    },
  },
  mounted() {
    this.getServices();
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
